import { Injectable } from "@angular/core";
import { UploadBatchNativeReportSdk } from "../sdks/upload-batch-native-report.sdk";
import { UploadBatchProductionReportSdk } from "../sdks/upload-batch-production-report.sdk";
import { BehaviorSubject, Observable } from "rxjs";
import { UploadBatchNativeReport } from "@models/ui/upload-batch-native-report.model";
import { UploadBatchProductionReport } from "@models/ui/upload-batch-production-report.model";

@Injectable({
    providedIn: 'root'
})
export class ValidationReportManager {
    public currentNativeValidationReport$: Observable<UploadBatchNativeReport>;
    public currentProductionValidationReport$: Observable<UploadBatchProductionReport>;
    
    private currentNativeValidationReportSource: BehaviorSubject<UploadBatchNativeReport> = new BehaviorSubject<UploadBatchNativeReport>(null);
    private currentProductionValidationReportSource: BehaviorSubject<UploadBatchProductionReport> = new BehaviorSubject<UploadBatchProductionReport>(null);
	
    constructor(
        private nativeReportSdk: UploadBatchNativeReportSdk,
        private productionReportSdk: UploadBatchProductionReportSdk) {
        this.currentNativeValidationReport$ = this.currentNativeValidationReportSource.asObservable();
        this.currentProductionValidationReport$ = this.currentProductionValidationReportSource.asObservable();
    }

    public setCurrentNativeUploadBatchReport(id: string): void {
        this.nativeReportSdk.get({ id }).subscribe(response => this.currentNativeValidationReportSource.next(response));
    }

    public clearNativeUploadBatchReport():void{
        this.currentNativeValidationReportSource.next(null);
    }

    public setCurrentProductionUploadBatchReport(id: string): void {
        this.productionReportSdk.get({ id }).subscribe(response => this.currentProductionValidationReportSource.next(response));
    }

    public clearProductionUploadBatchReport(): void {
        this.currentProductionValidationReportSource.next(null);
    }
}